import React, { useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  Autocomplete,
  useJsApiLoader,
} from "@react-google-maps/api";
import { Button, notification } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  setChangeDefault,
  setPabiliPadalaDetails,
} from "../redux/feature/order";
import { useDispatch, useSelector } from "react-redux";
import { FaMapPin, FaLocationDot } from "react-icons/fa6";

const GOOGLE_MAPS_LIBRARIES = ["places"];

const CustomerLocationMap = () => {
  const location = useLocation();
  const { type, lat, lng } = location.state || {};

  const { pabiliPadalaDetails } = useSelector((state) => state.order);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [isDragging, setIsDragging] = useState(false);

  const [markerPosition, setMarkerPosition] = useState({
    lat: Number(lat),
    lng: Number(lng),
  });

  const autocompleteRef = useRef(null);
  const mapRef = useRef(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const openNotification = () => {
    api.error({
      message: "Error",
      description:
        "Make sure the pick-up and drop-off locations are not the same.",
      showProgress: true,
    });
  };

  // const handleMarkerDragEnd = (event) => {
  //   const newCoords = {
  //     lat: event.latLng.lat(),
  //     lng: event.latLng.lng(),
  //   };

  //   setMarkerPosition(newCoords);
  // };

  const handleCenterChanged = useCallback(() => {
    if (mapRef.current) {
      const newCenter = mapRef.current.getCenter();
      const newLatLng = { lat: newCenter.lat(), lng: newCenter.lng() };

      // Only update state if the position has actually changed
      if (
        newLatLng.lat !== markerPosition.lat ||
        newLatLng.lng !== markerPosition.lng
      ) {
        setMarkerPosition(newLatLng);
      }
    }
    setIsDragging(false);
  }, [markerPosition]);

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handlePlaceSelected = () => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry) {
      const { lat, lng } = place.geometry.location;
      const newCoords = { lat: lat(), lng: lng() };

      setMarkerPosition(newCoords);

      mapRef.current.panTo(newCoords);
    }
  };

  const handleConfirmLocation = async () => {
    setLoading(true);

    let currentData = { ...pabiliPadalaDetails.finalCustomerDetails };

    try {
      const { data: branchLocation } = await axios.get(
        `https://api.dorydelivery.com/api/utility/get-province-city?latitude=${markerPosition.lat}&longitude=${markerPosition.lng}`
      );

      let pickupDetails = {};
      let dropOffDetails = {};

      if (type === "pickup") {
        pickupDetails = {
          pickupLocation: {
            locationText: `${branchLocation.result.city}, ${branchLocation.result.province}`,
            coordinates: {
              latitude: markerPosition.lat,
              longitude: markerPosition.lng,
            },
          },
          pickUpLocationRiderToCheck: {
            province: branchLocation.result.province,
            city: branchLocation.result.city,
          },
        };
      } else if (type === "dropoff") {
        dropOffDetails = {
          dropOffLocation: {
            locationText: `${branchLocation.result.city}, ${branchLocation.result.province}`,
            coordinates: {
              latitude: markerPosition.lat,
              longitude: markerPosition.lng,
            },
          },
        };
      }

      const updatedDetails = {
        ...currentData,
        ...pickupDetails,
        ...dropOffDetails,
      };

      // validation

      if (
        updatedDetails.pickupLocation?.coordinates &&
        updatedDetails.dropOffLocation?.coordinates
      ) {
        const { latitude: pickupLat, longitude: pickupLng } =
          updatedDetails.pickupLocation.coordinates;

        const { latitude: dropOffLat, longitude: dropOffLng } =
          updatedDetails.dropOffLocation.coordinates;

        const roundedPickupLat = parseFloat(pickupLat.toFixed(4));
        const roundedPickupLng = parseFloat(pickupLng.toFixed(4));

        const roundedDropOffLat = parseFloat(dropOffLat.toFixed(4));
        const roundedDropOffLng = parseFloat(dropOffLng.toFixed(4));

        if (
          roundedPickupLat === roundedDropOffLat &&
          roundedPickupLng === roundedDropOffLng
        ) {
          openNotification();
          setLoading(false);
          return;
        }
      }

      if (type === "dropoff") {
        dispatch(setChangeDefault(true));
      }

      dispatch(
        setPabiliPadalaDetails({ finalCustomerDetails: updatedDetails })
      );
      navigate("/pabili-padala-checkout");
    } catch (error) {
      console.log(">>> Something went wrong geocoding the place");
    } finally {
      setLoading(false);
    }
  };

  if (loadError) return <div>Error loading Google Maps</div>;
  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      {contextHolder}
      <div
        style={{
          position: "absolute",
          top: "5px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 10,
          backgroundColor: "white",
          padding: "10px 20px",
          borderRadius: "10px",
          fontSize: "14px",
          fontWeight: "bold",
          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
          width: "90%",
        }}
      >
        {type === "pickup"
          ? "I-pin o hanapin ang lugar kung saan mo gustong mag pabili!"
          : "I-pin o hanapin ang lugar kung saan ipapadala ang iyong order!"}
      </div>

      <div
        style={{
          position: "relative",
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        {/* <GoogleMap
          mapContainerStyle={{
            height: "100%",
            width: "100%",
          }}
          zoom={16}
          options={{
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true,
            rotateControl: false,
            gestureHandling: "greedy",
            scaleControl: false,
          }}
          center={markerPosition}
          onLoad={(mapInstance) => (mapRef.current = mapInstance)}
        >
          <Marker
            position={markerPosition}
            draggable={true}
            onDragEnd={handleMarkerDragEnd}
          ></Marker>
        </GoogleMap> */}

        <GoogleMap
          mapContainerStyle={{
            height: "100%",
            width: "100%",
          }}
          zoom={16}
          options={{
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            zoomControl: true,
            rotateControl: false,
            gestureHandling: "greedy",
            scaleControl: false,
          }}
          center={markerPosition}
          onLoad={(mapInstance) => (mapRef.current = mapInstance)}
          onDragStart={handleDragStart}
          onIdle={handleCenterChanged}
        >
          {/* <Marker position={markerPosition} /> */}
        </GoogleMap>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -100%)",
            zIndex: 10,
            fontSize: "40px",
            color: "#00BF63",
          }}
        >
          {isDragging ? <FaMapPin /> : <FaLocationDot />}
        </div>
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "90%",
            zIndex: 10,
            backgroundColor: "white",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
            borderRadius: "20px",
          }}
        >
          <Autocomplete
            onLoad={(instance) => (autocompleteRef.current = instance)}
            onPlaceChanged={handlePlaceSelected}
            options={{
              componentRestrictions: { country: "ph" },
              fields: ["name", "geometry.location"],
            }}
          >
            <input
              type="text"
              placeholder="Search for a location"
              style={{
                width: "100%",
                height: "48px",
                padding: "5px 10px",
                fontSize: "16px",
                border: "none",
                outline: "none",
                borderRadius: "20px",
                boxSizing: "border-box",
              }}
            />
          </Autocomplete>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
          position: "absolute",
          top: "90%",
          width: "100%",
        }}
      >
        <Button
          type="primary"
          style={{
            zIndex: 10,
            padding: "10px 20px",
            fontSize: "16px",
            width: "90%",
            height: "40px",
            borderRadius: "20px",
            backgroundColor: "#00BF63",
          }}
          onClick={handleConfirmLocation}
          disabled={loading}
          loading={loading}
        >
          Confirm Location
        </Button>
      </div>
    </>
  );
};

export default CustomerLocationMap;
